import React from "react";
import { Case, Default, Switch } from "react-if";

import { useDeviceType, DeviceType } from "@src/packages/chime-ui/hooks/useDeviceType";
import { EnableCameraAccessAndroid } from "@src/views/EnableCameraAccessAndroid";
import { EnableCameraAccessIphone } from "@src/views/EnableCameraAccessIphone";

interface Props {
  onComplete: () => void;
}

export const EnableCameraAccess = ({ onComplete }: Props) => {
  const deviceType = useDeviceType();

  return (
    <Switch>
      <Case condition={deviceType === DeviceType.Android}>
        <EnableCameraAccessAndroid onComplete={onComplete} />
      </Case>
      <Default>
        <EnableCameraAccessIphone onComplete={onComplete} />
      </Default>
    </Switch>
  );
};
